// import { useEffect, useRef, useState } from "react";
// import { useAIChat } from "../../context/AIChatContext";
// import { useMarketIndicators } from "../../context/MarketIndicatorContext";
// import "./ChatPanel.css";

// const STOCK_SUMMARY_PROMPT = `
// Role: Act as a Senior Equity Research Analyst specializing in the Indian NSE market.

// Task: Analyze the provided stock data and generate a professional equity research report covering:

// 1. Executive Summary:
// - 2-line summary including company name and current market price status.

// 2. Current Sentiment:
// - Bullish, Bearish, or Neutral with justification using price action, RSI, MACD, PCR.

// 3. Buy / Sell / Hold Rationale:
// - Fundamental Factors: P/E ratio, profit margins, upside potential.
// - Technical Factors: RSI levels, MACD trend and momentum.

// 4. Verdict:
// - Clear Buy, Sell, or Hold recommendation.

// 5. Wealth Creation Analysis:
// - Use returns (1W to 5Y) to classify as Wealth Creator or Wealth Destroyer.
// - Compare short-term vs long-term performance.

// 6. Derivatives Sentiment (PCR):
// - Explain implications if PCR is above or below 1.0.

// 7. MACD Histogram & Trend Analysis:
// - Histogram momentum (size/color)
// - MACD/Signal crossovers
// - Trend acceleration or exhaustion

// Formatting rules:
// - Use bold headings
// - Bullet points
// - Concise, factual, professional
// - No generic disclaimers
// `;

// const ChatPanel = ({ stockContext }) => {
//   const { chatOpen, closeChat } = useAIChat();
//   const { sendPrompt, messages, loading, error } = useMarketIndicators();

//   const [input, setInput] = useState("");
//   const bottomRef = useRef(null);
//   const [isSummaryMode, setIsSummaryMode] = useState(false);
//   const [inputLocked, setInputLocked] = useState(false);

//   // Auto scroll on new message
//   useEffect(() => {
//     bottomRef.current?.scrollIntoView({ behavior: "smooth" });
//   }, [messages, loading]);

//   // Normal typed chat
//   const handleSend = () => {
//     if (!input.trim() || loading) return;
//     sendPrompt(input.trim());
//     setIsSummaryMode(false);
//     setInputLocked(false);
//     setInput("");
//   };

//   // Stock summary button
//   const handleStockSummary = () => {
//     if (!stockContext || loading) return;

//     // Show user intent in chat
//     sendPrompt(
//       STOCK_SUMMARY_PROMPT,
//       {
//         type: "STOCK_SUMMARY",
//         stockData: stockContext,
//       },
//       {
//         showAsUser: "Summary of this stock",
//       },
//     );
//   };

//   return (
//     <div className={`chat-panel ${chatOpen ? "open" : ""}`}>
//       {/* Header */}
//       <div className="chat-header">
//         <h3>AI Assistant</h3>
//         <button
//           onClick={() => {
//             // setDisabled(false);
//             closeChat();
//           }}
//         >
//           ✕
//         </button>
//       </div>

//       {/* Messages */}
//       <div className="chat-messages">
//         {messages?.map((msg, idx) => (
//           <div
//             key={idx}
//             className={`chat-bubble ${msg.role} ${msg.error ? "error" : ""}`}
//           >
//             {msg.text}
//           </div>
//         ))}

//         {stockContext && (
//           <div className="chat-top-tab">
//             <button
//               className="chat-chip"
//               onClick={handleStockSummary}
//               disabled={loading}
//             >
//               Summary of this stock
//             </button>
//           </div>
//         )}

//         {loading && (
//           <div className="chat-bubble ai typing">AI is typing...</div>
//         )}

//         <div ref={bottomRef} />
//       </div>

//       {/* Error */}
//       {error && <div className="chat-error">{error}</div>}

//       {/* Quick Actions */}

//       {/* Input */}
//       <div className="chat-input">
//         <input
//           value={input}
//           onChange={(e) => setInput(e.target.value)}
//           placeholder="Ask something..."
//           onKeyDown={(e) => e.key === "Enter" && handleSend()}
//           disabled={disabled}
//         />
//         <button onClick={handleSend} disabled={disabled}>
//           Send
//         </button>
//       </div>
//     </div>
//   );
// };

// export default ChatPanel;

import { useEffect, useRef, useState } from "react";
import { useAIChat } from "../../context/AIChatContext";
import { useMarketIndicators } from "../../context/MarketIndicatorContext";
import "./ChatPanel.css";

const STOCK_SUMMARY_PROMPT = `
Role: Act as a Senior Equity Research Analyst specializing in the Indian NSE market.

Task: Analyze the provided stock data and generate a professional equity research report covering:

1. Executive Summary:
- 2-line summary including company name and current market price status.

2. Current Sentiment:
- Bullish, Bearish, or Neutral with justification using price action, RSI, MACD, PCR.

3. Buy / Sell / Hold Rationale:
- Fundamental Factors: P/E ratio, profit margins, upside potential.
- Technical Factors: RSI levels, MACD trend and momentum.

4. Verdict:
- Clear Buy, Sell, or Hold recommendation.

5. Wealth Creation Analysis:
- Use returns (1W to 5Y) to classify as Wealth Creator or Wealth Destroyer.
- Compare short-term vs long-term performance.

6. Derivatives Sentiment (PCR):
- Explain implications if PCR is above or below 1.0.

7. MACD Histogram & Trend Analysis:
- Histogram momentum (size/color)
- MACD/Signal crossovers
- Trend acceleration or exhaustion

Formatting rules:
- Use bold headings
- Bullet points
- Concise, factual, professional
- No generic disclaimers
`;

// const ChatPanel = ({ stockContext }) => {
//   const { chatOpen, closeChat } = useAIChat();
//   const { sendPrompt, messages, loading, error } = useMarketIndicators();
//   const [inputDisabled, setInputDisabled] = useState(false);

//   const [input, setInput] = useState("");
//   const bottomRef = useRef(null);

//   const [isSummaryMode, setIsSummaryMode] = useState(false);
//   const [inputLocked, setInputLocked] = useState(false);

//   const lastPromptRef = useRef(null); // ✅ ADDED

//   // Auto scroll
//   useEffect(() => {
//     bottomRef.current?.scrollIntoView({ behavior: "smooth" });
//   }, [messages, loading]);

//   // 🔁 UNLOCK INPUT after AI finishes (success or error)
//   useEffect(() => {
//     if (!loading && inputLocked) {
//       setInputLocked(false);
//       setIsSummaryMode(false);
//     }
//   }, [loading]);

//   // Normal typed chat
//   const handleSend = () => {
//     if (!input.trim() || inputDisabled) return;

//     lastPromptRef.current = input; // ✅ STORE PROMPT
//     setIsSummaryMode(false);
//     setInputLocked(false);
//     setInputDisabled(false);
//     sendPrompt(input.trim());
//     setInput("");
//   };

//   // Stock summary button
//   const handleStockSummary = () => {
//     if (!stockContext || loading) return;

//     setIsSummaryMode(true); // ✅ ADDED
//     setInputLocked(true); // ✅ ADDED
//     lastPromptRef.current = STOCK_SUMMARY_PROMPT; // ✅ STORE
//     setInputDisabled(true);
//     sendPrompt(STOCK_SUMMARY_PROMPT);
//   };

//   useEffect(() => {
//     if (!loading && inputDisabled) {
//       setInputDisabled(false);
//     }
//   }, [loading]);

//   return (
//     <div className={`chat-panel ${chatOpen ? "open" : ""}`}>
//       {/* Header */}
//       <div className="chat-header">
//         <h3>AI Assistant</h3>
//         <button
//           onClick={() => {
//             setInputLocked(false);
//             closeChat();
//           }}
//         >
//           ✕
//         </button>
//       </div>

//       {/* Messages */}
//       <div className="chat-messages">
//         {messages?.map((msg, idx) => (
//           <div
//             key={idx}
//             className={`chat-bubble ${msg.role} ${msg.error ? "error" : ""}`}
//           >
//             {msg.text || msg.content || msg.message}
//           </div>
//         ))}

//         {/* 🔝 SUMMARY CHIP AT TOP */}
//         {stockContext && (
//           <div className="chat-top-tab">
//             <button
//               className="chat-chip"
//               onClick={handleStockSummary}
//               disabled={loading}
//             >
//               Summary of this stock
//             </button>
//           </div>
//         )}

//         {loading && (
//           <div className="chat-bubble ai typing">AI is typing...</div>
//         )}

//         <div ref={bottomRef} />
//       </div>

//       {/* Error */}
//       {error && <div className="chat-error">{error}</div>}

//       {/* Input */}
//       <div className="chat-input">
//         <input
//           onClick={() => console.log("INPUT CLICKED")}
//           value={input}
//           onChange={(e) => {
//             console.log("CHANGE", e.target.value);
//             setInput(e.target.value);
//           }}
//           placeholder={
//             isSummaryMode ? "Generating stock summary..." : "Ask something..."
//           }
//           onKeyDown={(e) => e.key === "Enter" && handleSend()}
//           disabled={inputDisabled}
//         />
//         <button
//           onClick={() => {
//             console.log("Send button clicked!");
//             handleSend();
//           }}
//           disabled={inputDisabled}
//         >
//           Send
//         </button>
//       </div>
//     </div>
//   );
// };
const ChatPanel = ({ stockContext }) => {
  const { chatOpen, closeChat } = useAIChat();
  const { sendPrompt, messages, loading, error } = useMarketIndicators();

  const [input, setInput] = useState("");
  const [inputDisabled, setInputDisabled] = useState(false);
  const [isSummaryMode, setIsSummaryMode] = useState(false);

  const bottomRef = useRef(null);
  const lastPromptRef = useRef(null);

  // Auto-scroll
  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, loading]);

  // Unlock input when AI finishes
  useEffect(() => {
    if (!loading && inputDisabled) {
      setInputDisabled(false);
      setIsSummaryMode(false);
    }
  }, [loading]);

  // Send normal chat
  //   const handleSend = () => {
  //     if (!input.trim() || inputDisabled) return;

  //     lastPromptRef.current = input;
  //     sendPrompt(input.trim());
  //     setInput("");
  //   };
  const handleSend = () => {
    if (!input.trim()) return;

    lastPromptRef.current = input;
    sendPrompt(input.trim()); // 🔥 always adds message
    setInput("");
  };

  // Send stock summary
  const handleStockSummary = () => {
    if (!stockContext || inputDisabled) return;

    setIsSummaryMode(true);
    setInputDisabled(true);

    lastPromptRef.current = STOCK_SUMMARY_PROMPT;
    sendPrompt(STOCK_SUMMARY_PROMPT);
  };

  return (
    <div className={`chat-panel ${chatOpen ? "open" : ""}`}>
      {/* Header */}
      <div className="chat-header">
        <h3>AI Assistant</h3>
        <button onClick={closeChat}>✕</button>
      </div>

      {/* Messages */}
      <div className="chat-messages">
        {messages?.map((msg, idx) => (
          <div
            key={idx}
            className={`chat-bubble ${msg.role} ${msg.error ? "error" : ""}`}
          >
            {msg.text || msg.content || msg.message}
          </div>
        ))}

        {stockContext && (
          <div className="chat-top-tab">
            <button
              className="chat-chip"
              onClick={handleStockSummary}
              disabled={inputDisabled}
            >
              Summary of this stock
            </button>
          </div>
        )}

        {loading && (
          <div className="chat-bubble ai typing">AI is typing...</div>
        )}

        <div ref={bottomRef} />
      </div>

      {/* Error */}
      {error && <div className="chat-error">{error}</div>}

      {/* Input */}
      <div className="chat-input">
        {/* <input
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder={
            isSummaryMode ? "Generating stock summary..." : "Ask something..."
          }
          onKeyDown={(e) => e.key === "Enter" && handleSend()}
          disabled={inputDisabled}
        /> */}
        <input
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSend()}
          disabled={loading || inputDisabled}
        />

        <button onClick={handleSend} disabled={loading || inputDisabled}>
          Send
        </button>

        <button onClick={handleSend} disabled={inputDisabled}>
          Send
        </button>
      </div>
    </div>
  );
};

export default ChatPanel;
// export default ChatPanel;
